import { InputSize, InputTheme } from 'components/common/types/Input.types';

const whiteColor = 'var(--neutral-100)';

const lightControlStyles = {
  border: '0',
  backgroundColor: 'transparent',
} as const;

const lightInputStyles = {
  color: 'var(--neutral-950-opacity-80)',
} as const;

const whiteWithBorderControlStyles = {
  border: '0',
  backgroundColor: 'transparent',
} as const;

const whiteWithBorderInputStyles = {
  color: 'var(--essential-tertiary)',
} as const;

const sectionButtonInputStyles = {
  color: 'var(--neutral-950)',
} as const;

export const groupHeadingStyles = {
  backgroundColor: 'var(--neutral-50)',
  color: 'var(--neutral-950-opacity-60)',
  fontWeight: 700,
  letterSpacing: '0.1em',
  textTransform: 'uppercase' as const,
  fontSize: '9px',
  lineHeight: '.75rem',
  padding: '0.5em 1em 0.2em 1.4em',
};

export const asyncSelectThemeStyles = {
  control: {
    [InputTheme.LIGHT]: lightControlStyles,
    [InputTheme.FLAT_GRAY]: lightControlStyles,
    [InputTheme.ITALIC_WHITE]: lightControlStyles,
    [InputTheme.WHITE_WITH_BORDER]: whiteWithBorderControlStyles,
    [InputTheme.SECTION_BUTTON]: lightControlStyles,
    [InputTheme.DARK]: {
      border: '1px solid var(--neutral-100-opacity-5)',
      borderLeftColor: whiteColor,
      backgroundColor: 'var(--neutral-100-opacity-10)',
      '&:hover': {
        borderColor: 'var(--neutral-100-opacity-5)',
        borderLeftColor: whiteColor,
        backgroundColor: 'var(--neutral-100-opacity-5)',
      },
    },
  },
  input: {
    [InputTheme.LIGHT]: lightInputStyles,
    [InputTheme.FLAT_GRAY]: lightInputStyles,
    [InputTheme.ITALIC_WHITE]: lightInputStyles,
    [InputTheme.WHITE_WITH_BORDER]: whiteWithBorderInputStyles,
    [InputTheme.SECTION_BUTTON]: sectionButtonInputStyles,
    [InputTheme.DARK]: {
      color: whiteColor,
    },
  },
  size: {
    control: {
      [InputSize.EXTRA_SMALL]: {
        height: '24px',
        // body-sm
        fontSize: '11px',
        lineHeight: '1.25rem',
        fontWeight: '400',
      },
      [InputSize.SMALL]: {},
      [InputSize.MEDIUM]: {},
      [InputSize.LARGE]: {},
    },
    input: {
      [InputSize.EXTRA_SMALL]: {
        margin: 0,
      },
      [InputSize.SMALL]: {},
      [InputSize.MEDIUM]: {},
      [InputSize.LARGE]: {},
    },
  },
};
